export default "__VITE_ASSET__CggsD6M4__"